import React from 'react';

import { IResolvedDetailedReview } from '@/src/utils/collections/review.mapper';
import { ReviewHeader } from '@/src/components/review/ReviewDetailed/ReviewHeader/ReviewHeader';
import { ReviewNoteList } from '@/src/components/review/ReviewDetailed/ReviewNote/ReviewNoteList';

export const ReviewDetailed = ({
  title,
  notes,
  noteIos,
  noteAndroid,
  linkToPlayStore,
  linkToAppStore,
}: IResolvedDetailedReview) => {
  return (
    <div className={`mx-auto max-w-1200 py-18`}>
      <div className="flex flex-col justify-center gap-12 lg:flex-row">
        <ReviewHeader
          title={title}
          noteIos={noteIos}
          noteAndroid={noteAndroid}
          linkToPlayStore={linkToPlayStore}
          linkToAppStore={linkToAppStore}
        />
        <ReviewNoteList notes={notes} />
      </div>
    </div>
  );
};
